export const WRAPPER_PADDING = [2, null, 7, 10];
